var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashIconGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2.5,
    fill: "#C9EDB8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.90625 14.2188C7.32325 14.2188 10.6335 14.6758 13.7792 15.532C14.2336 15.6557 14.6875 15.3179 14.6875 14.847V14.2188M4.84375 5.3125V5.78125C4.84375 6.04013 4.63388 6.25 4.375 6.25H3.90625M3.90625 6.25V6.01563C3.90625 5.6273 4.22105 5.3125 4.60938 5.3125H15.1562M3.90625 6.25V11.875M15.1562 5.3125V5.78125C15.1562 6.04013 15.3661 6.25 15.625 6.25H16.0938M15.1562 5.3125H15.3906C15.779 5.3125 16.0938 5.6273 16.0938 6.01563V12.1094C16.0938 12.4977 15.779 12.8125 15.3906 12.8125H15.1562M16.0938 11.875H15.625C15.3661 11.875 15.1562 12.0849 15.1562 12.3438V12.8125M15.1562 12.8125H4.84375M4.84375 12.8125H4.60937C4.22105 12.8125 3.90625 12.4977 3.90625 12.1094V11.875M4.84375 12.8125V12.3438C4.84375 12.0849 4.63388 11.875 4.375 11.875H3.90625M11.875 9.0625C11.875 10.098 11.0355 10.9375 10 10.9375C8.96447 10.9375 8.125 10.098 8.125 9.0625C8.125 8.02697 8.96447 7.1875 10 7.1875C11.0355 7.1875 11.875 8.02697 11.875 9.0625ZM13.75 9.0625H13.7547V9.06719H13.75V9.0625ZM6.25 9.0625H6.25469V9.06719H6.25V9.0625Z",
    stroke: "#3A8B12",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashIconGreen);
export default __webpack_public_path__ + "static/media/cashIconGreen.91b1fde02786f328cffdbcb7c0166053.svg";
export { ForwardRef as ReactComponent };